import { createContext, Dispatch, SetStateAction } from 'react'

// Create context for selected nodes
export interface FlowchartContextType {
  selectedNodes: string[]
  setSelectedNodes: Dispatch<SetStateAction<string[]>>
}

export const FlowchartContext = createContext<FlowchartContextType>({
  selectedNodes: [],
  setSelectedNodes: () => {},
})
